import { render, staticRenderFns } from "./DesignButton.vue?vue&type=template&id=54d4c154&scoped=true&"
import script from "./DesignButton.vue?vue&type=script&lang=js&"
export * from "./DesignButton.vue?vue&type=script&lang=js&"
import style0 from "./DesignButton.vue?vue&type=style&index=0&id=54d4c154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4c154",
  null
  
)

export default component.exports